<template>
   <v-container class="pt-4 pb-12 py-sm-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Histórico de Vendas</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Histórico de vendas',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row class="mt-0 mt-sm-4">
    <v-col>
        <v-card :loading="dataset.loading" class="home-card-details">
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <span class="text-h6 mr-4 home-card-details-title">
                                    Filtros
                                </span>
                            </v-col>
                        </v-row>
<v-row align="center">
    <v-col cols="12" sm="4">
        <v-select :disabled="dataset.loading" v-on:change="normalizeRangeByType" dense
            :items="dataset.periodTypes" label="Período" v-model="dataset.filterSelected"
            item-value="type" item-text="label" outlined :rules="[$rules.required]" required
            hide-details="auto">
        </v-select>
    </v-col>
    <v-col cols="12" sm="4">
        <v-text-field v-model="dataset.rangeDate.startDate" type="datetime-local"
            :disabled="dataset.filterSelected != 9" dense label="Data início" required outlined
            hide-details>
        </v-text-field>
    </v-col>
    <v-col cols="12" sm="4">
        <v-text-field v-model="dataset.rangeDate.endDate" type="datetime-local"
            :disabled="dataset.filterSelected != 9" dense label="Data fim" required outlined
            hide-details>
        </v-text-field>
    </v-col>
</v-row>
<v-row align="center">
    <v-col cols="12" sm="4">
        <v-select dense :items="dataset.machineTypes" label="Tipo de serviço"
            v-model="dataset.filter.machineType" item-value="id" item-text="name" outlined
            hide-details="auto">
        </v-select>
    </v-col>
    <v-col cols="12" sm="4">
        <v-select dense :items="dataset.paymentTypes" label="Tipo de pagamento"
            v-model="dataset.filter.paymentType" item-value="id" item-text="name" outlined
            hide-details="auto">
        </v-select>
    </v-col>
    <v-col cols="12" sm="4" class="d-flex align-center">
        <div class="button-group d-flex w-100" style="gap: 8px; width: 100%;">
            <v-btn :loading="dataset.loading" type="button" elevation="0" color="primary" height="40" style="flex: 1; min-width: 0;"
                @click="loadData()">Filtrar</v-btn>
            <v-btn :disabled="dataset.loading" type="button" elevation="0" outlined
                color="primary" height="40" style="flex: 1; min-width: 0;" @click="exportReport()">Exportar</v-btn>
        </div>
    </v-col>
</v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
               <v-data-table 
    :headers="dataList.headers" 
    :items="dataList.data" 
    :server-items-length="dataList.count"
    :disable-sort="true"
    :loading="dataList.loading" 
    no-data-text="Nenhuma venda foi encontrada"
    loading-text="Carregando dados..." 
    class="app-table hover-table sale-history-table"
    :options.sync="dataList.options"
    :footer-props="dataList.footerOptions"
>
    <template v-slot:[`item.date`]="{ item }">
        {{ item.data | defaultDate("DD/MM/YYYY HH:mm:ss") }}
    </template>

    <template v-slot:[`item.amount`]="{ item }">
        R$ {{ item.valor | currency }}
    </template>

    <template v-slot:[`item.coupon`]="{ item }">
        <span v-if="item.cupomDesconto">
            {{ item.cupomDesconto.codigo || '-' }}
        </span>
        <span v-else>-</span>
    </template>

    <template v-slot:[`item.discount`]="{ item }">
        R$ {{ item.valorDesconto | currency }}
    </template>

    <template v-slot:[`item.total`]="{ item }">
        R$ {{ item.valorFinal | currency }}
    </template>

    <template v-slot:[`item.description`]="{ item }">
        {{ getSaleDescription(item.vendaItens) }}
    </template>

   <template v-slot:[`item.paymentType`]="{ item }">
    {{ getEnum(item.tipoPagamento, dataset.paymentTypes) }}
    <img v-if="item.tipoPagamento === 'PIX'" :src="getFlagIcon('PIX')" class="flag-icon" style="vertical-align:middle; margin-left:4px;" />
    <img v-else-if="item.tipoPagamentoBandeira" :src="getFlagIcon(item.tipoPagamentoBandeira)" class="flag-icon" style="vertical-align:middle; margin-left:4px;" />
</template>

<template v-slot:[`item.cliente`]="{ item }">
    {{ item.cliente ? (item.cliente.nome || item.cliente) : '-' }}
</template>
    <!-- <template v-slot:[`item.nfseStatus`]="{ item }">
        <v-chip
            small
            :color="item.nfseId ? 'success' : 'grey lighten-1'"
            outlined
            label
        >
            <v-icon left x-small>
                {{ item.nfseId ? 'mdi-check-circle' : 'mdi-minus-circle' }}
            </v-icon>
            <strong>{{ item.nfseId ? 'Emitida' : 'Pendente' }}</strong>
        </v-chip>
    </template> -->

    <template v-slot:[`item.actions`]="{ item }">
    <div style="display:flex; align-items:center; gap:8px;">
        <v-icon @click="viewItem(item)" size="large" title="Ver Detalhes">
            mdi-eye-outline
        </v-icon>

        <v-icon @click="viewProof(item)" size="large" title="Ver Comprovante">
            mdi-invoice-list-outline
        </v-icon>

      <!-- <v-icon 
    :color="item.nfseId ? 'primary' : 'orange'" 
    @click="handleNFSe(item)" 
    size="large"
    :title="item.nfseId ? 'Ver Nota Fiscal' : 'Gerar Nota Fiscal'"
>
    {{ item.nfseId ? 'mdi-file-document-outline' : 'mdi-file-plus-outline' }}
</v-icon> -->

    </div>
</template>
          
</v-data-table>

                <div class="mobile-custom-pagination d-flex d-sm-none">
                    <div class="popup-pagination-topo">
                        <v-select
                            :items="dataList.footerOptions.itemsPerPageOptions"
                            v-model="dataList.options.itemsPerPage"
                            dense
                            outlined
                            hide-details
                            class="popup-itens-por-pagina"
                        />
                        <span class="popup-pagination-label">
                            Página {{ dataList.options.page }} de {{ totalPaginasVendas }}
                        </span>
                    </div>
                    <div class="popup-pagination-botoes">
                        <v-btn text small color="primary" :disabled="dataList.options.page <= 1" @click="paginaAnteriorVendas">
                            <v-icon left small>mdi-chevron-left</v-icon>
                            Anterior
                        </v-btn>
                        <v-btn text small color="primary" :disabled="dataList.options.page >= totalPaginasVendas" @click="paginaProximaVendas">
                            Próxima
                            <v-icon right small>mdi-chevron-right</v-icon>
                        </v-btn>
                    </div>
                </div>

                <v-divider></v-divider>
            </v-col>
        </v-row>

        <v-dialog v-if="dataset.selectedSale" v-model="dataset.dialog" :width="560">
            <v-card class="sale-summary">
                <div class="sale-summary-header">
                    <h1 class="sale-summary-title">Resumo da venda</h1>
                    <v-btn icon small @click="dataset.dialog = false" title="Fechar">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <div class="sale-summary-hero">
                    <div>
                        <div class="sale-summary-label">Valor final</div>
                        <div class="sale-summary-total">R$ {{ dataset.selectedSale.valorFinal | currency }}</div>
                    </div>
                    <div class="sale-summary-date">
                        <v-icon small class="mr-1">mdi-calendar-clock</v-icon>
                        {{ dataset.selectedSale.data | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                    </div>
                </div>

                <div class="sale-summary-grid">
                    <div class="sale-summary-field">
                        <div class="sale-summary-label">Pagamento</div>
                        <div class="sale-summary-value">
                            <img v-if="dataset.selectedSale.tipoPagamento === 'PIX'" :src="getFlagIcon('PIX')" class="sale-summary-flag" />
                            <img v-else-if="dataset.selectedSale.tipoPagamentoBandeira && getFlagIcon(dataset.selectedSale.tipoPagamentoBandeira)" :src="getFlagIcon(dataset.selectedSale.tipoPagamentoBandeira)" class="sale-summary-flag" />
                            {{ getEnum(dataset.selectedSale.tipoPagamento, dataset.paymentTypes) }}
                            <span v-if="['CREDITO', 'DEBITO'].includes(dataset.selectedSale.tipoPagamento) && dataset.selectedSale.tipoPagamentoBandeira">
                                ({{ dataset.selectedSale.tipoPagamentoBandeira }})
                            </span>
                        </div>
                    </div>

                    <div class="sale-summary-field">
                        <div class="sale-summary-label">Cupom</div>
                        <div class="sale-summary-value">
                            {{ dataset.selectedSale.cupomDesconto ? dataset.selectedSale.cupomDesconto.codigo : '-' }}
                        </div>
                    </div>

                    <div class="sale-summary-field">
                        <div class="sale-summary-label">Desconto</div>
                        <div class="sale-summary-value" :class="{ 'red--text': dataset.selectedSale.valorDesconto > 0 }">
                            <template v-if="dataset.selectedSale.valorDesconto > 0">- </template>R$ {{ dataset.selectedSale.valorDesconto | currency }}
                        </div>
                    </div>

                    <div class="sale-summary-field" v-if="dataset.selectedSale.cliente">
                        <div class="sale-summary-label">Cliente</div>
                        <div class="sale-summary-value">
                            {{ dataset.selectedSale.cliente.nome || dataset.selectedSale.cliente }}
                            <v-btn v-if="dataset.selectedSale.cliente.id" x-small text color="primary" class="sale-summary-link"
                                @click="$router.push('/clientes/' + dataset.selectedSale.cliente.id)">
                                Ver cliente
                            </v-btn>
                        </div>
                    </div>
                </div>

                <div class="sale-summary-items" v-if="dataset.selectedSale.vendaItens && dataset.selectedSale.vendaItens.length">
                    <div class="sale-summary-label mb-1">Itens da venda</div>
                    <div class="sale-summary-item" v-for="(item, index) in dataset.selectedSale.vendaItens" :key="index">
                        <span class="sale-summary-item-index">{{ index + 1 }}</span>
                        <span class="sale-summary-item-desc">{{ item.descricao }}</span>
                        <span class="sale-summary-item-price">
                            R$ {{ item.valor | currency }}
                            <small v-if="item.valorDesconto && item.valorDesconto > 0" class="red--text">
                                - R$ {{ item.valorDesconto | currency }}
                            </small>
                        </span>
                    </div>
                </div>

                <v-card-actions class="sale-summary-actions">
                    <v-spacer></v-spacer>
                    <v-btn text @click="dataset.dialog = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-if="dataset.selectedSale" v-model="dataset.dialogProof" :width="450">
            <v-card class='pa-3'>
                <v-card-title>
                    <v-row justify="center">
                        <v-col lg="12">
                            <h1 class="custom-modal-title text-uppercase black--text font-weight-bold">
                                Comprovante
                            </h1>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-tabs v-model="dataset.selectedProof">
                        <v-tab>Cliente</v-tab>
                        <v-tab>Empresa</v-tab>
                    </v-tabs>
                </v-card-text>
                <v-card-text ref="proofDiv">
                    <div class="d-none d-sm-flex proof-container">
                        <span class="text-block">
                            {{ dataset.selectedProof == 0 ? dataset.selectedSale.comprovanteCliente :
                                dataset.selectedSale.comprovanteEmpresa }}
                        </span>
                    </div>
                    <div class="d-sm-none d-lg-none d-md-flex proof-container">
                        <span class="text-block-mobile">
                            {{ dataset.selectedProof == 0 ? dataset.selectedSale.comprovanteCliente :
                                dataset.selectedSale.comprovanteEmpresa }}
                        </span>
                    </div>
                </v-card-text>
                            <v-card-actions>
    <v-btn text @click="dataset.dialogProof = false">Fechar</v-btn>
    <v-btn color="primary" dark @click="printProof(dataset.selectedProof == 0 ? dataset.selectedSale.comprovanteCliente :
        dataset.selectedSale.comprovanteEmpresa)">Imprimir</v-btn>
</v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import machineTypes from "@/common/data/machine-types.data"
import paymentTypes from "@/common/data/payment-types.data"
import flagTypes from "@/common/data/flag-types.data"

import { eventHub } from "@/main"
import { jsPDF } from "jspdf";

Vue.use(VueLodash)

export default {
    name: "PaymentTotemList",

    data: () => ({
        dataset: {
            paymentTypes: [{ "id": null, "name": "Todos" }, ...paymentTypes],
            machineTypes: [{ "id": null, "name": "Todos" }, ...machineTypes],
            flagTypes: flagTypes,
            data: {},
            operation: null,
            dialog: false,
            dialogProof: false,
            selectedSale: null,
            filterSelected: 1,
            selectedProof: 0,
            loading: false,
            rangeDate: { startDate: null, endDate: null },
            datePickerStartDialog: false,
            datePickerEndDialog: false,
            filter: {
                name: "",
                paymentType: null,
                machineType: null
            },
            periodTypes: [
                {
                    label: 'Hoje',
                    type: 1
                },
                {
                    label: 'Ontem',
                    type: 2
                },
                {
                    label: '7 dias',
                    type: 3
                },
                {
                    label: '15 dias',
                    type: 4
                },
                {
                    label: '30 dias',
                    type: 5
                },
                {
                    label: 'Esse mês',
                    type: 6
                },
                {
                    label: 'Mês passado',
                    type: 7
                },
                {
                    label: 'Últimos 3 meses',
                    type: 8
                },
                {
                    label: 'Personalizado',
                    type: 9
                },
            ]
        },
        dataList: {
    headers: [
        { text: "Data", value: "date" },
        { text: "Valor", value: "amount" },
        { text: "Cupom", value: "coupon" },
        { text: "Valor desconto", value: "discount" },
        { text: "Valor final", value: "total" },
        { text: "Descrição", value: "description" },
        { text: "Tp. Pagamento", value: "paymentType" },
        { text: "Cliente", value: "cliente", sortable: false },
        // { text: "NFSe", value: "nfseStatus", align: 'center', sortable: false },
        { text: 'Ações', value: 'actions', sortable: false },
            ],
          data: [],
            loading: false,
            count: 0,
            loadSeq: 0,
            options: {
            page: 1,
            itemsPerPage: 10,
            sortBy: ['name'],
            sortDesc: [false],
             },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20],
                // disableItemsPerPage: true,
                pageText: '{0}-{1} de {2}',
            },

        },
    }),

   mounted() {
    this.getSelectedOperation();

    if (!this.dataset.operation) {
        this.$dialog.notify.error('Nenhuma operação selecionada!', { position: 'top-right', timeout: 5000 });
        return;
    }

    eventHub.$on('CHANGE-OPERATION', () => {
        this.getSelectedOperation();
        this.loadData();
    });
},
    destroyed() {
        eventHub.$off('CHANGE-OPERATION')
    },

  computed: {
        totalPaginasVendas() {
            const total = this.dataList.count || 0;
            const porPagina = this.dataList.options.itemsPerPage || 10;
            return Math.max(1, Math.ceil(total / porPagina));
        }
    },

    methods: {
        paginaAnteriorVendas() {
            if (this.dataList.options.page > 1) {
                this.dataList.options.page--;
            }
        },

        paginaProximaVendas() {
            if (this.dataList.options.page < this.totalPaginasVendas) {
                this.dataList.options.page++;
            }
        },

        getColorByStatus(status) {
            switch (status) {
                case 0:
                    return 'warning'
                case 1:
                    return 'accent'
                case 2:
                    return 'error'
                default:
                    break;
            }
        },

        getSaleDescription(itens) {
            return itens.map((x) => x.descricao).join(', ')
        },

        getEnum(value, data) {
    if (!data || !Array.isArray(data)) return value;
    const item = data.find(item => item['id'] === value);
    return item ? item['name'] : value;
},

        printProof(proof) {
            const normalizedProof = proof.toString().replace(/^\s+|\s+$/gm, '');

            const doc = new jsPDF('p', 'mm', [120, 110]);

            doc.setFillColor(255, 255, 210);
            doc.rect(0, 0, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight(), 'F');


            doc.setFont("Courier New")
            doc.setFontSize(12);
            doc.text(normalizedProof, 10, 20)

            doc.save("comprovante.pdf");
        },

        getSelectedOperation() {
            this.dataset.operation = localStorage.getItem('operation');
        },

       loadData() {
    if (this.dataList.options.page === 1) {
        this.load();
    } else {
        this.dataList.options.page = 1;
    }
},

        getFlagIcon(flag) {
            const resultFlag = this.dataset.flagTypes.find((x) => x.id == flag);

            return resultFlag ? require(`../../assets/icons/${resultFlag.icon}`) : '';
        },

       async load() {
            this.dataList.loading = true;

            this.normalizeRangeByType();

            if (this.dataset.filterSelected == 9 && (!this.dataset.rangeDate.startDate || !this.dataset.rangeDate.endDate)) {
                this.dataList.loading = false;
                return;
            }

            const seq = ++this.dataList.loadSeq;

            try {
                let dataIni = this.dataset.rangeDate.startDate;
                let dataFim = this.dataset.rangeDate.endDate;

                let params = { 
                    dataInicial: dataIni, 
                    dataFinal: dataFim, 
                    operacaoId: this.dataset.operation, 
                    page: this.dataList.options.page - 1, 
                    size: this.dataList.options.itemsPerPage 
                };

                if (this.dataset.filter.paymentType) params.tipoPagamento = this.dataset.filter.paymentType;
                if (this.dataset.filter.machineType) params.tipoProduto = this.dataset.filter.machineType;

                const result = await axios.get('/api/venda', { params });

                if (seq !== this.dataList.loadSeq) return;

                this.dataList.data = result.data.content;
                this.dataList.count = result.data.page ? result.data.page.totalElements : (result.data.totalElements || 0);

            } catch (error) {
                if (seq === this.dataList.loadSeq) {
                    this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
                }
            } finally {
                if (seq === this.dataList.loadSeq) this.dataList.loading = false;
            }
        },
        async exportReport() {

            this.dataset.loading = true;

            try {

                let params = { dataInicial: this.dataset.rangeDate.startDate, operacaoId: this.dataset.operation, dataFinal: this.dataset.rangeDate.endDate };

                if (this.dataset.filter.paymentType) params.tipoPagamento = this.dataset.filter.paymentType;
                if (this.dataset.filter.machineType) params.tipoProduto = this.dataset.filter.machineType;

                const result = await axios.get(`/api/venda/relatorio/export-to-excel`, { params, responseType: 'arraybuffer' });

                let blob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'Relatório de vendas.xlsx'
                link.click()

                this.$dialog.notify.info("Vendas exportas com sucesso!", { position: "top-right", timeout: 2000 });
             } catch (error) {
    var mensagem = this.$codes(error);
if (error && error.response && error.response.data) {
    try {
        var decoded = JSON.parse(new TextDecoder().decode(error.response.data));
        if (decoded.mensagem) mensagem = decoded.mensagem;
    } catch (e) { /* ignora */ }
}
    this.$dialog.notify.error(mensagem, { position: 'top-right', timeout: 5000 });
}  finally {
                this.dataset.loading = false;
            }
            // const href = URL.createObjectURL(result.data);

            // // create "a" HTML element with href to file & click
            // const link = document.createElement('a');
            // link.href = href;
            // link.setAttribute('download', 'file.pdf'); //or any other extension
            // document.body.appendChild(link);
            // link.click();

            // // clean up "a" element & remove ObjectURL
            // document.body.removeChild(link);
            // URL.revokeObjectURL(href);

            // this.resolveChartLastUsers(result.data.content)
        },

        normalizeRangeByType() {
            switch (this.dataset.filterSelected) {
                case 1:
                    this.dataset.rangeDate.startDate = this.$moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss');
                    this.dataset.rangeDate.endDate = this.$moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
                    break;
                case 2:
                    this.dataset.rangeDate.startDate = this.$moment().subtract(1, 'd').startOf('day').format('YYYY-MM-DDTHH:mm:ss');
                    this.dataset.rangeDate.endDate = this.$moment().subtract(1, 'd').endOf('day').format('YYYY-MM-DDTHH:mm:ss');
                    break;
                case 3:
                    this.dataset.rangeDate.startDate = this.$moment().subtract(6, 'd').startOf('day').format('YYYY-MM-DDTHH:mm:ss');
                    this.dataset.rangeDate.endDate = this.$moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
                    break;
                case 4:
                    this.dataset.rangeDate.startDate = this.$moment().subtract(15, 'd').startOf('day').format('YYYY-MM-DDTHH:mm:ss');
                    this.dataset.rangeDate.endDate = this.$moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
                    break;
                case 5:
                    this.dataset.rangeDate.startDate = this.$moment().subtract(30, 'd').startOf('day').format('YYYY-MM-DDTHH:mm:ss');
                    this.dataset.rangeDate.endDate = this.$moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
                    break;
                case 6:
                    this.dataset.rangeDate.startDate = this.$moment().startOf('month').format('YYYY-MM-DDTHH:mm:ss');
                    this.dataset.rangeDate.endDate = this.$moment().endOf('month').format('YYYY-MM-DDTHH:mm:ss');
                    break;
                case 7:
                    this.dataset.rangeDate.startDate = this.$moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DDTHH:mm:ss');
                    this.dataset.rangeDate.endDate = this.$moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DDTHH:mm:ss');
                    break;
                case 8:
                    this.dataset.rangeDate.startDate = this.$moment().subtract(3, 'month').format('YYYY-MM-DDTHH:mm:ss');
                    this.dataset.rangeDate.endDate = this.$moment(new Date()).format('YYYY-MM-DDTHH:mm:ss');
                    break;

                default:
                    break;
            }
        },

        viewItem(item) {
            this.dataset.selectedSale = item;
            this.dataset.dialog = true;
            // this.$router.push(`upboxes/${item.id}`);
        },

        viewProof(item) {
            this.dataset.selectedSale = item;
            this.dataset.dialogProof = true;
            // this.$router.push(`upboxes/${item.id}`);
        },

  // async handleNFSe(item) {
//     if (item.nfseId) {
//         this.$dialog.notify.info("Abrindo Nota Fiscal...");
//         window.open(`/api/venda/nfse/pdf/${item.nfseId}`, '_blank');
//         return;
//     }
//     const confirm = await this.$dialog.confirm({
//         title: 'Emissão de NFSe',
//         text: `Deseja gerar a nota fiscal para esta venda no valor de R$ ${this.$options.filters.currency(item.valorFinal)}?`,
//         actions: { false: 'Cancelar', true: 'Sim, Gerar Nota' }
//     });
//     if (confirm) {
//         try {
//             this.dataList.loading = true;
//             const response = await axios.post(`/api/venda/${item.id}/emitir-nfse`);
//             this.$dialog.notify.success("NFSe gerada com sucesso!");
//             await this.load();
//         } catch (error) {
//             this.$dialog.notify.error(this.$codes(error) || "Falha ao comunicar com o serviço de notas.");
//         } finally {
//             this.dataList.loading = false;
//         }
//     }
// }
    },

   watch: {
    'dataList.options': {
        handler: _.debounce(function() {
            this.load();
        }, 300),
        deep: true,
        immediate: true,
        flush: 'post'
    }
},

};
</script>

<style>

/* borda/padding/min-height base do modo mobile do .app-table agora é global (assets/scss/main.scss) */
/* Selector com .sale-history-table pra não vazar pra tabelas de outras telas
   (esse <style> não é scoped — sem essa classe, a regra valia globalmente). */
@media (max-width: 768px) {
  .app-table.sale-history-table.v-data-table--mobile .v-data-table__mobile-row {
    width: 100% !important;
    display: flex !important;
    justify-content: space-between !important;
  }

  .app-table.sale-history-table.v-data-table--mobile .v-data-table__mobile-row__cell {
    text-align: right !important;
  }
}

.flag-icon {
    width: 30px;
}

.custom-modal-title {
    font-size: 20px;
}

.sale-summary {
    padding: 20px 24px 8px;
}

.sale-summary-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
}

.sale-summary-title {
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
    color: #111;
}

.sale-summary-label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #8a8f98;
}

.sale-summary-hero {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    padding: 14px 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    background-color: #f4f7fb;
}

.sale-summary-total {
    font-size: 28px;
    font-weight: 700;
    line-height: 1.2;
    color: var(--v-primary-base);
}

.sale-summary-date {
    font-size: 13px;
    color: #555;
}

.sale-summary-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px 24px;
    margin-bottom: 18px;
}

.sale-summary-value {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 2px;
    font-size: 14px;
    font-weight: 600;
    color: #222;
}

.sale-summary-flag {
    width: 24px;
}

.sale-summary-link.v-btn {
    min-width: 0 !important;
    padding: 0 6px !important;
    text-transform: none;
}

.sale-summary-items {
    margin-bottom: 8px;
}

.sale-summary-item {
    display: flex;
    align-items: baseline;
    gap: 10px;
    padding: 8px 0;
    border-top: 1px solid #eee;
    font-size: 14px;
}

.sale-summary-item-index {
    flex: 0 0 auto;
    min-width: 18px;
    color: #8a8f98;
    font-weight: 600;
}

.sale-summary-item-desc {
    flex: 1 1 auto;
    font-weight: 600;
    color: #222;
}

.sale-summary-item-price {
    flex: 0 0 auto;
    text-align: right;
    font-weight: 600;
}

.sale-summary-item-price small {
    display: block;
    font-weight: 500;
}

.sale-summary-actions {
    padding: 8px 0 8px !important;
}

@media (max-width: 600px) {
    .sale-summary {
        padding: 16px 16px 4px;
    }

    .sale-summary-grid {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .sale-summary-total {
        font-size: 24px;
    }
}
@media (max-width: 600px) {
    .app-table.hover-table .v-data-footer {
        display: none !important;
    }
}

.mobile-custom-pagination {
    flex-direction: column;
    padding: 12px 4px 4px 4px;
    margin-top: 8px;
    border-top: 1px solid #eee;
    gap: 10px;
}

.popup-pagination-topo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.popup-itens-por-pagina {
    max-width: 80px;
    flex: 0 0 auto;
}

.popup-pagination-label {
    font-size: 13px;
    color: #666;
    font-weight: 600;
    white-space: nowrap;
}

.popup-pagination-botoes {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.popup-pagination-botoes .v-btn {
    min-width: auto !important;
    padding: 0 8px !important;
    font-size: 12px !important;
    text-transform: none;
}
.proof-container {
    background-color: #ffffd2 !important;
    padding-bottom: 30px;
    padding-left: 20px;
    padding-right: 20px;
}

.text-block {
    white-space: pre;
    font-family: "Courier New", serif !important;
    color: #000 !important;
    font-weight: bold;
    margin: 5px 0 0;
    font-size: 10pt;
    text-transform: uppercase;
}

.text-block-mobile {
    white-space: pre;
    font-family: "Courier New", serif !important;
    color: #000 !important;
    font-weight: bold;
    margin: 5px 0 0;
    font-size: 8.5pt;
    text-transform: uppercase;
}
</style>

